module.exports = __webpack_public_path__ + "img/caret-left.79ed8ff4.svg";